import { atom } from "recoil";

export const userUpdatedFlagState = atom<boolean>({
  key: "userUpdatedFlagState",
  default: false,
});
